import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import './styles.css';

class GlobalSearchFilterSelect extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  focus() {
    this.ref.current.focus();
  }

  handleChange = selectedOption => {
    if (this.props.onChange) {
      this.props.onChange(this.props.name, selectedOption);
    } else {
      this.props.controlFunc(selectedOption, this.props.name);
    }
  };

  handleOnBlur = e => {
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name, true, true);
    } else if (this.props.touchFunc) {
      this.props.touchFunc(e);
    }
  };

  shouldComponentUpdate(prevProps) {
    return !isEqual(this.props, prevProps);
  }

  render() {
    const {
      value,
      options,
      name,
      placeholder,
      isValid,
      isDisabled = false,
      isSearchable = true,
      blurInputOnSelect = true,
      isLast = false,
      filterOption,
    } = this.props;

    const customStyles = {
      control: base => ({ ...base, borderColor: isValid ? '#a0a0a0' : '#f40' }),
    };

    return (
      <div
        className={
          isLast
            ? 'global-search-filter-select__wrapper global-search-filter-select__wrapper--last'
            : 'global-search-filter-select__wrapper'
        }
      >
        <Select
          ref={this.ref}
          blurInputOnSelect={blurInputOnSelect}
          isSearchable={isSearchable}
          instanceId={Date.now()}
          value={value || options[0]}
          styles={customStyles}
          name={name}
          onChange={this.handleChange}
          options={options}
          className="global-search-filter-select"
          classNamePrefix="global-search-filter-select"
          placeholder={placeholder}
          onBlur={this.handleOnBlur}
          isDisabled={isDisabled}
          filterOption={filterOption}
        />
      </div>
    );
  }
}

GlobalSearchFilterSelect.propTypes = {
  isSearchable: PropTypes.bool,
  blurInputOnSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  value: PropTypes.object,
  options: PropTypes.array.isRequired,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  controlFunc: PropTypes.func,
  isValid: PropTypes.bool.isRequired,
  touchFunc: PropTypes.func,
  filterOption: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  isLast: PropTypes.bool,
};

export default GlobalSearchFilterSelect;
